import { DraggableAttributes } from "@dnd-kit/core";
import { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";
import { forwardRef } from "react";
import cx from "classnames";

import { DotsVertical } from "components/icons/generated";

import Box, { BoxProps } from "../Box";
import Icon from "../Icon";
import Typography, { TypographyProps } from "../Typography";
import styles from "./styles.module.css";
import Tooltip from "../Tooltip";

type DraggableItemHandleProps = Partial<BoxProps> &
  Partial<Pick<TypographyProps, "variant">> & {
    dragging?: boolean;
    handleListeners?: SyntheticListenerMap;
    handleAttributes?: DraggableAttributes;
    disabled?: boolean;
  };

const DraggableItemHandle = forwardRef<HTMLDivElement, DraggableItemHandleProps>(
  function DraggableItemHandle(
    {
      children,
      variant = "p-body3",
      dragging,
      handleListeners,
      handleAttributes,
      disabled,
      ...rest
    },
    ref
  ) {
    return (
      <Box align="center" gap="medium" {...rest}>
        <Tooltip
          ref={ref}
          active={!dragging && !disabled}
          on={(tooltipProps) => (
            <button
              {...tooltipProps}
              {...handleAttributes}
              {...handleListeners}
              aria-label="Drag and drop"
              className={cx(styles.handle, dragging && styles.dragging)}
              tabIndex={disabled ? -1 : 0}
              disabled={disabled}
            >
              <Icon src={DotsVertical} className={styles.handleIcon} size="default" noShrink />
            </button>
          )}
        >
          Drag and drop
        </Tooltip>
        {typeof children === "string" ? (
          <Typography tag="span" variant={variant}>
            {children}
          </Typography>
        ) : (
          children
        )}
      </Box>
    );
  }
);

DraggableItemHandle.displayName = "DS.DraggableItem.Handle";

export default DraggableItemHandle;
